import type { AiContext } from "@/types/ai/Context";

/**
 * Extracts AiContext from a pathname
 * Parses route and parameters from the URL path
 */
export function extractContextFromPathname(pathname: string): AiContext {
  const params: Record<string, string> = {};
  let route = "unknown";

  // Remove leading slash and split
  const parts = pathname.split("/").filter(Boolean);

  if (parts.length === 0) {
    return { pathname, route: "discover", params };
  }

  // Determine route from first segment
  const firstSegment = parts[0];
  if (["discover", "build", "my-data", "profile"].includes(firstSegment)) {
    route = firstSegment;
  }

  // Parse build route parameters: /build/:projectId/:dataflowId
  if (route === "build") {
    if (parts.length >= 2) {
      params.projectId = parts[1];
    }
    if (parts.length >= 3) {
      route = "workspace";
      params.dataflowId = parts[2];
    }
  }

  // Parse discover route parameters: /discover/:section
  if (route === "discover" && parts.length >= 2) {
    params.section = parts[1];
  }

  return {
    pathname,
    route,
    params,
  };
}
